module.exports = __webpack_public_path__ + "img/bingo_ball-85.2d36a517.png";